import Vue from 'vue';
import moment from 'moment';
import { HTTP, SEARCH } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultEvent = {
  dates: [],
  pub_date: new Date(),
  is_published: false,
  collection_ids: [],
  event_ids: [],
  ministry_ids: [],
  _embedded: {
    contact: {},
    form: {},
    location: {
      label: null,
      address: {},
    },
    ministries: [],
    packages: [
      { cost: 0, discount_cost: 0 },
    ],
  },
};

const parseDate = (date) => {
  if (!date) return null;
  return moment(date, 'YYYY-MM-DD').toDate();
};

const parseTime = (time) => {
  if (!time) return null;
  return moment(time, moment.ISO_8601).toDate();
};

export default {
  actions: {
    async [actions.DO_CREATE_EVENT]({ commit }, payload) {
      const { ignore, ...params } = payload;
      const { data } = await HTTP.post('/events', params);
      if (!ignore) commit(mutations.SET_EVENT, data.data.events[0]);
      return data;
    },
    // async [actions.DO_DUPLICATE_EVENT]({ commit }, params) {
    //   await HTTP.post(`/events/${params.id}`, params);
    // },
    async [actions.DO_GET_EVENT]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/events/${id}`, { params });
      commit(mutations.SET_EVENT, data.data.events[0]);
      return data;
    },
    async [actions.DO_GET_EVENTS]({ commit }, params) {
      const { data } = await HTTP.get('/events', { params });
      commit(mutations.SET_EVENTS, data.data.events);
      return data;
    },
    async [actions.DO_OVERRIDE_EVENT]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.put(`/events/${id}`, params);
      return data;
    },
    async [actions.DO_SEARCH_EVENTS]({ commit }, payload) {
      const { ignore, ...params } = payload;
      const { data } = await SEARCH.post('/doxa_events/event/_search', params);
      const events = data.hits.hits.map(h => h._source);
      if (!ignore) commit(mutations.SET_EVENTS, events);
      return data;
    },
    async [actions.DO_UPDATE_EVENT]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.patch(`/events/${id}`, params);
      return data;
    },
    async [actions.DO_DELETE_EVENT]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.delete(`/events/${id}`, params);
      return data;
    },
  },
  getters: {
    [getters.GET_EVENT]: state => state.event,
    [getters.GET_EVENT_FILTERS]: state => state.filters,
    [getters.GET_EVENTS]: state => state.events,
    [getters.GET_EVENTS_REFRESH]: state => state.refresh,
    [getters.GET_EVENTS_TAGS]: state => state.tags,
  },
  mutations: {
    [mutations.ADD_PACKAGE_FOR_EVENT](state, eventPackage) {
      state.event._embedded.packages.push(eventPackage);
    },
    [mutations.REMOVE_PACKAGE_FOR_EVENT](state, index) {
      state.event._embedded.packages.splice(index, 1);
    },
    [mutations.SET_EVENT](state, event) {
      const copy = _.cloneDeep(event);
      const dateFields = [
        'end_date',
        'pub_date',
        'registration_deadline',
        'start_date',
      ];
      dateFields.forEach((field) => {
        if (copy[field]) {
          copy[field] = parseDate(copy[field]);
        }
      });
      const timeFields = [
        'end_time',
        'start_time',
      ];
      timeFields.forEach((field) => {
        if (copy[field]) {
          copy[field] = parseTime(copy[field]);
        }
      });
      state.event = copy;
    },
    [mutations.SET_EVENT_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.event;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_EVENT_FILTER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.filters;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_EVENTS](state, events) {
      state.events = events;
    },
    [mutations.SET_EVENTS_REFRESH](state, refresh) {
      state.refresh = refresh;
    },
    [mutations.SET_PACKAGE_FIELD_FOR_EVENT](state, field) {
      const service = state.event._embedded.packages[field.index];
      Vue.set(service, field.key, field.val);
    },
    [mutations.TOGGLE_EVENTS_TAG](state, tag) {
      const index = _.findIndex(state.tags, { _id: tag._id });
      if (index < 0) {
        state.tags.push(tag);
      } else {
        state.tags.splice(index, 1);
      }
    },
    [mutations.UNSET_EVENT](state) {
      state.event = Object.assign({}, defaultEvent);
    },
  },
  state: {
    events: [],
    event: Object.assign({}, defaultEvent),
    filters: {
      status: 'current',
      pub: 'all',
      sort: {
        field: 'end_date',
        order: 'asc',
      },
    },
    refresh: false,
    tags: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/event.js